/**
 * Gera um UUID v4 compatível com browser e Node.js
 * @returns UUID v4 string
 */
export function generateUUID(): string {
  // Tenta usar crypto.randomUUID() se disponível (Node.js 19+ ou browser moderno)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Tenta usar crypto.webcrypto.randomUUID() no browser
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  // Fallback: implementação manual de UUID v4
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
